import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { And, RuleInterface, StringEquals } from '@vendasta/automata';
import { GalaxyInputModule, SelectInputOptionInterface } from '@vendasta/galaxy/input';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

export const OrderExpiryLabelMap = {
  ['NinetyDays']: 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_ORDER_EXPIRING.EXPIRY_OPTIONS.NINETY_DAYS',
  ['ThirtyDays']: 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_ORDER_EXPIRING.EXPIRY_OPTIONS.THIRTY_DAYS',
  ['OneDay']: 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_ORDER_EXPIRING.EXPIRY_OPTIONS.ONE_DAY',
};

@Component({
  selector: 'automata-sales-order-expiring-panel',
  styleUrls: ['./sales-order-expiring-panel.component.scss'],
  templateUrl: './sales-order-expiring-panel.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
    GalaxyInputModule,
  ],
})
export class SalesOrderExpiringPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  orderExpiryControl: UntypedFormControl = new UntypedFormControl('NinetyDays');
  orderExpiryOptions: SelectInputOptionInterface[] = Object.entries(OrderExpiryLabelMap).map(([value, label]) => ({
    label,
    value,
  })) as SelectInputOptionInterface[];

  descriptionKey = 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_ORDER_EXPIRING.ORIGIN_DESCRIPTION';

  ngOnInit(): void {
    super.ngOnInit();
    if (this.isWaitingForEvent) {
      this.descriptionKey = 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_ORDER_EXPIRING.ACCOUNT_SCOPED_ORIGIN_DESCRIPTION';
    }

    if (this.triggerChoices?.rules?.length > 0) {
      const and = And.fromRuleInterface(this.triggerChoices.rules[0]);

      const orderExpiryRule = and.value[0]?.value;

      this.orderExpiryControl.setValue(orderExpiryRule.toString());
    }

    this.orderExpiryOptions = this.orderExpiryOptions.map((option) => {
      if (option.value === this.orderExpiryControl.value) {
        option.selected = true;
      }
      return option;
    });
    this.savingEnabled$.next(true);
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.orderExpiryControl];
  }

  isFormValid(): boolean {
    return this.orderExpiryControl.valid;
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    const and = new And([new StringEquals('{.notify_period}', this.orderExpiryControl.value)], '');

    return [and.toRuleInterface()];
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    const and = And.fromRuleInterface(rules[0]);
    and.setValueByItsVariablePath('notify_period', this.orderExpiryControl.value);

    return [and.toRuleInterface()];
  }
}
